import * as LucideIcons from 'lucide-react';

// Map of icon names to Lucide React components
export const getIconComponent = (iconName: string | null | undefined, size: number = 24) => {
  if (!iconName) return null;

  // Normalize icon name to PascalCase for Lucide
  const pascalCase = iconName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');

  // Get the icon component from Lucide
  const IconComponent = (LucideIcons as any)[pascalCase];

  if (!IconComponent) {
    // Fallback to default icon if not found
    return <LucideIcons.Box size={size} />;
  }

  return <IconComponent size={size} />;
};

// Icon mapping for common shop types
export const shopTypeIcons: Record<string, keyof typeof LucideIcons> = {
  'pill': 'Pill',
  'shopping-cart': 'ShoppingCart',
  'smartphone': 'Smartphone',
  'shirt': 'Shirt',
  'book': 'Book',
  'utensils': 'Utensils',
  'wrench': 'Wrench',
  'store': 'Store',
  'package': 'Package',
  'wheat': 'Wheat',
  'pepper-hot': 'Flame',
  'cookie-bite': 'Cookie',
  'cookie': 'Cookie',
  'candy': 'Candy',
  'glass-water': 'GlassWater',
  'ice-cream': 'IceCream2',
  'spray-can': 'SprayCan',
  'soap': 'Droplet',
  'box': 'Box',
  'tags': 'Tags',
  'ruler': 'Ruler',
};

export const getShopIcon = (iconName: string | null | undefined, size: number = 24) => {
  if (!iconName) return <LucideIcons.Store size={size} />;

  const normalizedName = iconName.toLowerCase();
  const IconName = shopTypeIcons[normalizedName] || 'Store';
  const IconComponent = (LucideIcons as any)[IconName];

  if (!IconComponent) {
    return <LucideIcons.Store size={size} />;
  }

  return <IconComponent size={size} />;
};
